import { VueQueryPlugin, VueQueryPluginOptions } from '@tanstack/vue-query';
import { App } from 'vue';

/**
 * Resolves an HTTP status from common Axios / API error shapes so retries
 * can skip non-transient client errors (4xx), except 429.
 */
const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const err = error as {
    status?: number;
    httpStatus?: number;
    response?: { status?: number };
  };

  return err.response?.status ?? err.httpStatus ?? (typeof err.status === 'number' ? err.status : undefined);
};

export const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        staleTime: 0,
        retry: (failureCount, error) => {
          const status = getErrorStatus(error);

          // Client errors are not transient — don't burn retries (except rate limits).
          if (status && status >= 400 && status < 500 && status !== 429) {
            return false;
          }

          return failureCount < 3;
        },
        refetchOnWindowFocus: false,
      },
    },
  },
};

export default {
  install(app: App) {
    app.use(VueQueryPlugin, vueQueryPluginOptions);
  },
};
